import type { TableColumnHeaderProps as ChakraTableColumnHeaderProps } from '@chakra-ui/react';
import { Th as ChakraTh } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export interface TableColumnHeaderProps
  extends OmitChakraProps<ChakraTableColumnHeaderProps> {
  /**
   * Set this `true` if using a form element (ie. Checkbox, Switch) to
   * align the cell content in the center.
   *
   * @default false
   */
  isFormElement?: boolean;

  /**
   * Set this `true` if using an actions menu to align the cell content to the
   * right.
   *
   * @default false
   */
  isActionsMenu?: boolean;
}

export const Th = withChakraAs<TableColumnHeaderProps, 'th'>(
  ({ isFormElement, isActionsMenu, ...props }) => {
    return (
      <ChakraTh
        data-is-form-element={isFormElement}
        data-is-actions-menu={isActionsMenu}
        {...props}
      />
    );
  },
);
